'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmOldMail = undefined;

var _ConfirmOldMail2 = require('./ConfirmOldMail');

var _ConfirmOldMail3 = _interopRequireDefault(_ConfirmOldMail2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ConfirmOldMail = _ConfirmOldMail3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/ConfirmOldMail/index.js
// module id = 1651
// module chunks = 0